import React from 'react';
import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@mui/material';
import { setSettings } from '../../../../support/slices/tileBuilderSlice';
import { ChartControlProps } from './ChartControlProps';

const TOOLTIP_MODES = [
  { value: 'auto', label: 'Auto (best effort)' },
  { value: 'seriesValue', label: 'Series + Value' },
  { value: 'labelValue', label: 'Label + Value' },
  { value: 'seriesLabelValue', label: 'Series + Label + Value' },
] as const;

const TOOLTIP_SIZES = [
  { value: 'small', label: 'Small' },
  { value: 'medium', label: 'Medium' },
  { value: 'large', label: 'Large' },
] as const;

const TOOLTIP_PLACEMENTS = [
  { value: 'top', label: 'Top' },
  { value: 'top-start', label: 'Top Start' },
  { value: 'top-end', label: 'Top End' },
  { value: 'right', label: 'Right' },
  { value: 'right-start', label: 'Right Start' },
  { value: 'right-end', label: 'Right End' },
  { value: 'bottom', label: 'Bottom' },
  { value: 'bottom-start', label: 'Bottom Start' },
  { value: 'bottom-end', label: 'Bottom End' },
  { value: 'left', label: 'Left' },
  { value: 'left-start', label: 'Left Start' },
  { value: 'left-end', label: 'Left End' },
] as const;

const ChartTooltipControls: React.FC<ChartControlProps> = ({ chartId, settings, dispatch }) => {
  const s: any = settings as any;

  const tooltipTrigger = s.tooltipTrigger ?? 'hover';
  const tooltipPlacement = s.tooltipPlacement ?? 'top';
  const tooltipSize = s.tooltipSize ?? 'small';

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, mt: 2 }}>
      <Typography variant="subtitle1">Tooltip</Typography>

      <FormControl fullWidth size="small">
        <InputLabel>Tooltip Mode</InputLabel>
        <Select
          label="Tooltip Mode"
          value={s.tooltipMode ?? 'auto'}
          onChange={(e) =>
            dispatch(setSettings({ chartId, settings: { tooltipMode: e.target.value as any } }))
          }
        >
          {TOOLTIP_MODES.map((m) => (
            <MenuItem key={m.value} value={m.value}>
              {m.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl fullWidth size="small">
        <InputLabel>Tooltip Placement</InputLabel>
        <Select
          label="Tooltip Placement"
          value={tooltipPlacement}
          onChange={(e) =>
            dispatch(setSettings({ chartId, settings: { tooltipPlacement: e.target.value as any } as any }))
          }
        >
          {TOOLTIP_PLACEMENTS.map((p) => (
            <MenuItem key={p.value} value={p.value}>
              {p.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl fullWidth size="small">
        <InputLabel>Tooltip Size</InputLabel>
        <Select
          label="Tooltip Size"
          value={tooltipSize}
          onChange={(e) =>
            dispatch(setSettings({ chartId, settings: { tooltipSize: e.target.value as any } as any }))
          }
        >
          {TOOLTIP_SIZES.map((sz) => (
            <MenuItem key={sz.value} value={sz.value}>
              {sz.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <TextField
        label="Tooltip Trigger"
        size="small"
        value={tooltipTrigger}
        onChange={(e) =>
          dispatch(setSettings({ chartId, settings: { tooltipTrigger: e.target.value } as any }))
        }
        helperText='Common: "hover", "click", "focus", or combinations'
      />

      <TextField
        label="Series Title"
        size="small"
        value={s.tooltipSeriesTitle ?? 'SE Phase'}
        onChange={(e) =>
          dispatch(setSettings({ chartId, settings: { tooltipSeriesTitle: e.target.value } }))
        }
      />
      <TextField
        label="Value Title"
        size="small"
        value={s.tooltipValueTitle ?? 'Count'}
        onChange={(e) =>
          dispatch(setSettings({ chartId, settings: { tooltipValueTitle: e.target.value } }))
        }
      />
      <TextField
        label="Label Title"
        size="small"
        value={s.tooltipLabelTitle ?? 'Email'}
        onChange={(e) =>
          dispatch(setSettings({ chartId, settings: { tooltipLabelTitle: e.target.value } }))
        }
      />
    </Box>
  );
};

export default ChartTooltipControls;